exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".project-tool-panel {\n  width: 100%;\n  padding: 0 15px;\n}\n", "", {"version":3,"sources":["/app/client/src/templates/Challenges/projects/tool-panel.css"],"names":[],"mappings":"AAAA;EACE,YAAW;EACX,gBAAe;CACjB","file":"tool-panel.css","sourcesContent":[".project-tool-panel {\n  width: 100%;\n  padding: 0 15px;\n}\n"],"sourceRoot":""}]);

// exports
